module.exports = __webpack_public_path__ + "img/paesaggio 4.95483240.jpeg";